import { UserLocaleId } from '@miq/user';

/**
 * @deprecated Use UserLocaleId instead
 * Locale is a unique combination of Country and Language
 */
export { UserLocaleId as LocaleId };

export interface LanguageLocale {
  localeKey: number;
  languageCode: string;
  defaultLanguage?: boolean;
  languageDesc?: string;
  languageName?: string;
}

export const PACIFC_COUNTRIES = [UserLocaleId.AustraliaEnglish, UserLocaleId.NewZealandEnglish];

export const LANGUAGE_BY_LOCALEID = { [UserLocaleId.ChinaEnglish]: 'English' };

export const DEPRECATED_LANGUAGES = [UserLocaleId.NlDutch];
